module.exports = __webpack_public_path__ + "img/IMG-purchaser-bg1.f53260ad.png";